import React, { useEffect } from "react";
import AwraaqLogos from "./AwraaqLogos";
import useIdleTimer from "../../utils/autoLogout";

function MainLogin() {
  useIdleTimer(() => {
    // Clear all stored data
    localStorage.removeItem("user_data");
    localStorage.removeItem("client_data");
    localStorage.removeItem("otp_login_data");
    localStorage.removeItem("otp_expire_at");
    localStorage.removeItem("otp_login_creds");

    // Redirect to home page
    window.location.href = "/";
  }, 900000);

  return (
    <div className="App">
      <AwraaqLogos />
    </div>
  );
}

export default MainLogin;
